import React, { useState,useEffect, useRef } from "react";
import { Button, Card, CardContent, GridLegacy as Grid, Stack, Typography } from '@mui/material';

import { useNavigate, useParams } from "react-router-dom";
import { AxiosInstance } from "../utils/constants";
import { AppContext, ActionTypes } from "../store/AppStore";
import { FormatPrice } from "../utils/constants";
import styled from "@emotion/styled";
import SignatureCanvas from 'react-signature-canvas';
import { CustomDialog } from "../components/modals/custom-dialog";
import { CustomLogoApp } from "../components/logo";
import { AppERoutesIndex } from "../route/app-routes";

const FirmaWidth = 400;
const FirmaHeight = 200;
const CenterContent = styled.div`
 display:flex;
 flex-direction:column;
 justify-content:center;
 height:100vh;
`;
const CenterText = styled.div`
text-align:center;
`;
const DocumentSign = styled.div`
  border: 1px solid #016B61;
  width:100%;
  height:100px;
  margin-left:auto;
  margin-right:auto;
`;

export const CrudFirma  = ()=>{


    const {cod_factura} = useParams();
    const {state,dispatch} = React.useContext(AppContext);
   const [dialogConfig,setDialogConfig] = useState([]);
    const {profile} = {...state};
    console.log({profile});
    const navigate = useNavigate();
    const canvasRef = useRef(null);
    useEffect(()=>{
        console.log({cod_factura});
       // loadInitData();
    },[]);



    const onSendFirma = ()=>{
        if ( canvasRef.current.isEmpty() ){
            setDialogConfig({
                isOpened:true,
                title:"No se detecto la firma",
                content:<p style={{fontFamily:"sans-serif"}} >Para continuar debes dibujar fu firma en el recuadro de color naranja</p>,
                actions:[
                    {
                        title:"Aceptar",
                        buttomProps:{
                            onClick:()=>setDialogConfig({}),
                            variant:"contained",
                            color:"primary" 
                        }

                    }
                ]
            });
        }else{
            if ( canvasRef.current.toData()[0].length <10 ){
                setDialogConfig({
                    isOpened:true,
                    title:"Tu firma no esta completa",
                    content:<p style={{fontFamily:"sans-serif"}} >Tu firma no cumple con los criterios basicos,Por favor intenta nuevamente</p>,
                    actions:[
                        {
                            title:"Aceptar",
                            buttomProps:{
                                onClick:()=>setDialogConfig({}),
                                variant:"contained",
                                color:"primary" 
                            }
    
                        }
                    ]
                });
            }else{
                dispatch({
                    type:ActionTypes.setLoadingPage,
                    payload:true
                  });
                AxiosInstance.post("sesion/crear-firma-usuario",{
                    firma:canvasRef.current.toDataURL()
                }).then(result=>{
                    setDialogConfig({
                        isOpened:true,
                        title:"Tu firma se ha creado ",
                        content:<p style={{fontFamily:"sans-serif"}} >Proceso exitoso, Ya puedes comprar</p>,
                        actions:[
                            {
                                title:"OK",
                                buttomProps:{
                                    onClick:()=> {
                                        setDialogConfig({});
                                        navigate(AppERoutesIndex.plataformaBase,{replace:true});
                                        window.location.reload();
                                    },
                                    variant:"contained",
                                    color:"primary" 
                                }
        
                            }
                        ]
                    });
                }).catch(err=>{

                    setDialogConfig({
                        isOpened:true,
                        title:"Error al guardar ",
                        content:<p style={{fontFamily:"sans-serif"}} >Se ha presentado un error al tratar de guardar la firma, por favor intenta nuevamente</p>,
                        actions:[
                            {
                                title:"Aceptar",
                                buttomProps:{
                                    onClick:()=>setDialogConfig({}),
                                    variant:"contained",
                                    color:"primary" 
                                }
        
                            }
                        ]
                    });

                }).finally(()=>{
                    dispatch({
                        type:ActionTypes.setLoadingPage,
                        payload:false
                      });
                });

            }
            console.log(canvasRef.current.toData());
            console.log("canva image");
        }
    }

    const borrarFirma = ()=>{
        canvasRef.current.clear();
    }

    return (<>
    <CustomDialog
     {...dialogConfig}
    />
        <Grid container >

         <Grid item sx={12} sm={12} md={12} >
            <CenterContent>
          {/*   <CenterText>
            <img src={Logo} width='190px' />
            </CenterText> */}
          
                <CenterText>
                    <CustomLogoApp />
                </CenterText>
                <CenterText>
                    <Typography typography={"h6"} >
                    Hola, {profile?.usuario}
                    
                    </Typography>
                    <Typography>
                    Para  poder vender por Acércate necesitamos que crees tu firma digital,
                    Es muy simple, trata de hacer una firma en el recuadro de abajo con tu dedo,
                    Esta firma aparecerá en los documentos oficiales de acercate
                    </Typography>
                </CenterText>
                <DocumentSign>
                <SignatureCanvas penColor={'black'}
                ref={canvasRef}
                canvasProps={{width: FirmaWidth, height: FirmaHeight, className: 'sigCanvas'}} />
                </DocumentSign>
                <Stack direction={"row"} justifyContent={"end"} marginTop={'10px'} >
                <Button  onClick={borrarFirma} sx={{marginRight:'10px'}} variant="contained" color="secondary" size="small" >Borrar</Button>
                    <Button onClick={onSendFirma} variant="contained" color="primary" size="small" >Continuar</Button>
                </Stack>
               
            </CenterContent>
           
         </Grid>

        </Grid>
        </>
    )

}